
import { post } from '@/lib/request/index';
import { user,actCgc } from '../apiConstants';

// 修改个人信息
export function updateUserInfo(param) {
  return post(user.UPDATE_USER_INFO, { param });
}

// 邀请好友接口
export function getRecActivity(param) {
  return post(actCgc.ACTIVITY_RECOMMEND, { param });
}

// 我的奖励列表
export function getRewardList(param) {
  return post(actCgc.REWARD_LIST, { param });
}

// 短链
export function getShortChain(param) {
  return post(actCgc.SHORT_CHAIN, { param });
}
